<span *ngIf="smallFont" style="font-size: 12px">{{ subspecialty }}</span>
<span
    *ngIf="!smallFont"
    style="font-size: 15px"
    [innerHtml]="subspecialty"
></span>
